var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',{attrs:{"width":180,"height":180,"primary":"#dddddd","secondary":"#bcbcbc"}},[_c('circle',{attrs:{"cx":"90","cy":"90","r":"90"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a9b7b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/widgets/content-loaders/SingleScreenshotRound.vue
// module id = null
// module chunks = 